module.exports = __webpack_public_path__ + "img/Venezuela, RB.c9336184.gif";